import { make as makeGroup } from './Group.gen'

type GroupProps = React.ComponentProps<typeof makeGroup>

const Group = makeGroup as React.FunctionComponent<GroupProps>

export { Group, type GroupProps }
